import { render, staticRenderFns } from "./UpVote.vue?vue&type=template&id=fd8d4a62&scoped=true&"
import script from "./UpVote.vue?vue&type=script&lang=js&"
export * from "./UpVote.vue?vue&type=script&lang=js&"
import style0 from "./UpVote.vue?vue&type=style&index=0&id=fd8d4a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8d4a62",
  null
  
)

export default component.exports